import { Grid } from '@mui/material'
import { BusinessInfoCard } from './BusinessInfoCard'
import { MediaCard } from './MediaCard'
import { SocialProfilesCard } from './SocialProfilesCard'
import { ServicesCard } from './ServicesCard'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import { BusinessDesCard } from './BusinessDesCard'
import PackagesCard from './PackagesCard'

export const VendorPublicProfile = ({
	formData,
	handleFileChange,
	setFormData,
	editable,
	canEditBusinessDetails = false,
}) => {
	const cardStyle = {
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '1em',
		padding: '1.5em',
		margin: '1em',
	}

	return (
		<div className={styles.vendorPublicProfile}>
			<Grid container alignItems={'unset'} spacing={{ xs: 2 }}>
				<Grid size={{ xs: 12, lg: 4.5 }}>
					<div>
						<BusinessInfoCard
							formData={formData}
							cardStyle={cardStyle}
							editable={canEditBusinessDetails}
							setFormData={setFormData}
						/>
						<MediaCard
							setFormData={setFormData}
							editable={editable}
							formData={formData}
							cardStyle={cardStyle}
							handleFileChange={handleFileChange}
						/>
					</div>
				</Grid>
				<Grid size={{ xs: 12, lg: 7.5 }}>
					<div>
						<BusinessDesCard
							formData={formData}
							cardStyle={cardStyle}
							editable={editable}
						/>
						<ServicesCard
							editable={editable}
							formData={formData}
							cardStyle={cardStyle}
						/>
						<PackagesCard cardStyle={cardStyle} />
						<SocialProfilesCard
							editable={editable}
							formData={formData}
							cardStyle={cardStyle}
							setFormData={setFormData}
						/>
					</div>
				</Grid>
			</Grid>
		</div>
	)
}
